import taskService from 'resources/task/task.service';
import { deleteTask } from './deleteTask';

/**
 * Delete all the tasks of a milestone
 * @param {string} id - The ID of the milestone whose tasks should be deleted
 * @returns {Promise<void>}
 */
const deleteAllMilestoneTasks = async (id) => {
  const milestoneTasks = await taskService.getMilestoneTasks(id);
  if (!milestoneTasks) return;

  await Promise.all(milestoneTasks.map(async (task) => {
    await deleteTask({ id: task.id });
  }));
};

export {
  deleteAllMilestoneTasks,
};
